/**
 * Runtime-config (INFRA-142).
 * Frontend läser /api/config vid start för att veta vilka features som är
 * aktiverade och vilken auth-provider som används. Konfig läses ENBART från
 * backend — ingen build-time bakning.
 */

import { http } from './httpClient';

let cachedConfig = null;
let inflight = null;

export async function fetchConfig({ force = false } = {}) {
  if (!force && cachedConfig) return cachedConfig;
  if (inflight) return inflight;

  inflight = http.get('/config').then((result) => {
    cachedConfig = result.data;
    inflight = null;
    return cachedConfig;
  }).catch((err) => {
    inflight = null;
    throw err;
  });

  return inflight;
}

export function clearConfigCache() {
  cachedConfig = null;
}

export function getConfigSync() {
  return cachedConfig;
}
